import Button from "../../../../components/Button/Button";
import { Section, Card } from "../Account/accountParts";
import { REMINDER_RECIPIENTS } from "./reminderRecipients";

const HEADERS = ["Reminder", "Send"];

const YesNoBadge = ({ value }) => (
  <span
    className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
      value ? "bg-success-100 text-success-800" : "bg-gray-100 text-gray-600"
    }`}
  >
    {value ? "Yes" : "No"}
  </span>
);

const RemindersView = ({ reminders, freelance, onEdit }) => {
  const shown = new Set(reminders.map((r) => r.reminder_type));
  const recipients = REMINDER_RECIPIENTS.filter((r) => shown.has(r.reminder_type));

  return (
    <div className="space-y-6">
      <Section
        title="Reminders"
        large
        actions={
          <Button size="sm" onClick={onEdit}>
            Update
          </Button>
        }
      >
        <Card>
          <div className="-mx-5 overflow-x-auto">
            <table className="w-full min-w-[480px] table-auto border-collapse">
              <thead>
                <tr className="border-b bg-white text-[10px] uppercase tracking-widest text-gray-500">
                  {HEADERS.map((h) => (
                    <th
                      key={h}
                      className="px-3 py-2 text-left font-semibold whitespace-nowrap first:pl-5 last:pr-5"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reminders.map((row, index) => (
                  <tr
                    key={row.reminder_type}
                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                  >
                    <td className="py-2 pl-5 pr-3 text-xs font-medium text-gray-900 whitespace-nowrap">
                      {row.label}
                    </td>
                    <td className="w-32 py-2 pl-3 pr-5 text-xs whitespace-nowrap">
                      <YesNoBadge value={row.enabled} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </Section>

      <Section title="Recipients of Reminders">
        <Card>
          <div className="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
            {recipients.map((group) => (
              <div key={group.reminder_type}>
                <h3 className="mb-1.5 text-sm font-semibold text-gray-900">{group.title}</h3>
                <ul className="list-disc space-y-0.5 pl-5 text-xs text-gray-700">
                  {(freelance ? ["You (account owner)"] : group.recipients).map((name) => (
                    <li key={name}>{name}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Card>
      </Section>
    </div>
  );
};

export default RemindersView;